import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/designs/demo/[heroId]/client.tsx");
